import { type FC, Fragment } from 'react';

type Props = {
  /** Фрагмент текста комментария; переносы строк сохраняются как `<br />` */
  text: string;
};

/** Обычный (без маркеров) фрагмент комментария с сохранением переносов строк. */
export const CommentTextLines: FC<Props> = ({ text }) => (
  <>
    {text.split('\n').map((line, index) => (
      <Fragment key={index}>
        {index > 0 && <br />}
        {line}
      </Fragment>
    ))}
  </>
);
